export const REELS_BASE_PATH = '/digital-marketing/reels';

export const buildReelsPath = (subPath = '') => {
    const normalizedSubPath = subPath.replace(/^\/+/, '');

    return normalizedSubPath
        ? `${REELS_BASE_PATH}/${normalizedSubPath}`
        : REELS_BASE_PATH;
};
